import { useQuery } from '@tanstack/react-query';
import moment from 'moment';
import useAxios from '../../../../hooks/useAxios';

const useAppErrorProbe = () => {
	const { get } = useAxios();
	return useQuery(['probe', moment().format('YYYY-MM-DD HH:mm')], async () => {
		return get('probe')
			.then((response) => response.data === 'alive')
			.catch(() => {
				// FIXME: Do something if error
				return false;
			});
	});
};

export default useAppErrorProbe;
